<template>
  <div class="popup-wrapper" @click.self="close">
    <div class="popup-container md">
      <div class="button close">
        <span role="button" class="btn" @click="close">
          <FontawesomeIcon :icon="['fal','times']" size="lg" class="icn" />
        </span>
      </div>
      <div class="popup">
        <div class="popup-title">
          <span class="hdg02">表示設定</span>
        </div>
        <div class="popup-content">
          <div class="popup-content-block">
            <span class="txt mr20">1ページに表示する件数</span>
            <SelectBox
              :selected="selectbox.selected"
              :lists="selectbox.lists"
              @change="selectBoxOnChange"
              />
          </div>
          <div class="popup-content-block">
            <div v-for="setting in displaySettings" :key="setting.value" :class="['formparts', 'checkbox', setting.disabled && 'is-disable']">
              <input type="checkbox" :value="setting.value" :id="'display_settings_' + setting.value" v-model="saveParams.hidden_keys" :disabled="setting.disabled">
              <label role="button" :for="'display_settings_' + setting.value">{{setting.name}}<FontawesomeIcon icon="check" class="icn" /></label>
            </div>
            <div class="button mt32">
              <button class="btn" type="submit" name="Knowledge_display_settings"
                @click="submit"
              >設定</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, reactive, ref, computed } from '@vue/composition-api'
import SelectBox from '@/components/pc/partial/SelectBox.vue'

export default defineComponent({
  neme: 'PCKnowledgeDisplaySetting',
  components: {
    SelectBox
  },
  setup (props, context) {
    const store = context.root.$store
    const { knowledge } = store.state

    const saveParams = reactive({
      per_page: knowledge.search.per_page,
      hidden_keys: knowledge.hidden_keys
    })

    const selectbox = reactive({
      selected: saveParams.per_page,
      lists: [
        { name: '30件', value: 30 },
        { name: '50件', value: 50 },
        { name: '100件', value: 100 }
      ]
    })

    const displaySettings = reactive([
      { name: 'タイトル', value: 'title', disabled: true },
      { name: '本文', value: 'detail' },
      { name: '作成日', value: 'created' },
      { name: 'ノート', value: 'note_count' },
      { name: 'カテゴリ', value: 'knowledge_category' }
    ])

    const close = () => {
      context.emit('closeDisplaySettings')
    }
    const submit = () => {
      const save = {
        hidden_keys: saveParams.hidden_keys,
        per_page: selectbox.selected 
      }
      store.dispatch('knowledge/setSearchOption', save)

      // 詳細画面から一覧画面に戻ってきた時のスクロール位置指定用IDをクリア
      store.dispatch('knowledge/setSelectedListItemId', 0)


      context.emit('closeDisplaySettings')
    }

    const selectBoxOnChange = (selected) => {
      selectbox.selected = selected
    }

    return {
      displaySettings,
      saveParams,
      selectbox,
      close,
      submit,
      selectBoxOnChange
    }
  }
})
</script>

<style lang="scss" scoped>
  .popup-content {
    padding: 0!important;
    &-block {
      padding: 40px;
      .txt,
      .select {
        display: inline-block;
      }
      & + .popup-content-block {
        border-top: 1px solid $color-line;
      }
    }
  }
  .popup-content .button {
    width: 267px;
    margin-right: auto;
    margin-left: auto;
  }
</style>
